import React, { memo } from 'react'
import { useLatestNews, LatestNewsProps } from './useLatestNews'
import styles from './LatestNews.module.scss'
import { Link } from 'react-router-dom'

const LatestNews: React.FC<LatestNewsProps> = (props: LatestNewsProps) => {
  const { image, title, link, date, isWhite } = useLatestNews(props)

  return (
    <div className={styles['latest-news']}>
      <img
        src={image}
        width={80}
        height={80}
        alt='Latest news media'
        className={`${styles.image} flex-shrink-0`}
      />
      <div>
        <h4 className={styles.title}>
          <Link
            to={link}
            className={`${styles.link} ${isWhite ? styles.white : ''}`}
          >
            {title}
          </Link>
        </h4>
        <time
          dateTime={date}
          className={`${styles.date} ${isWhite ? styles.white : ''}`}
        >
          {date}
        </time>
      </div>
    </div>
  )
}

export default memo(LatestNews)
